<template>
  <!-- 进件失败兜底页：isRedirectProductsPage !== 1 时跳转，引导下载 APP -->
  <div class="page">
    <img
      class="page__icon"
      src="../../public/img/common/check_icon.png"
      alt=""
    />
    <span class="page__title">您的借款申请提交成功</span>
    <div class="page__line"></div>

    <div class="page__row">
      <span class="page__label">借款金额</span>
      <span class="page__value">￥{{ loanAmount }}</span>
    </div>
    <div class="page__row">
      <span class="page__label">借款时间</span>
      <span class="page__value">{{ curTime }}</span>
    </div>

    <p class="page__hint">
      本平台所有服务免费，以官方名义收费，或在服务签收费的行为，均为诈骗！
    </p>

    <div class="page__btn" @click="handleDownload">同意，去APP激活额度</div>

    <SharePop :show="showPop" @change="handlePopChange" />
  </div>
</template>

<script>
/**
 * 非贷超兜底结果页
 * 进件推送失败且 isRedirectProductsPage !== 1 时进入
 * 下载逻辑对齐 trialSuccess_tl9.handleDownload
 */
import * as API_Common from "@/api/common.js";

export default {
  name: "ApplyResult",
  data() {
    const query = this.$route.query;
    return {
      channelNo: query.source || "",
      loanAmount: query.loanAmount || query.amount || 0,
      brand: query.brand || "",
      curTime: "",
      downAppUrl: "",
      showPop: false,
    };
  },
  mounted() {
    this.curTime = this.formatNow();
    this.getDownloadUrl();
  },
  methods: {
    formatNow() {
      const d = new Date();
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },

    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channelNo, true).then((res) => {
        if (res?.code === 200) {
          this.downAppUrl = res.data.url;
        } else {
          this.$toast.fail("获取下载地址失败,请重试");
        }
      });
    },

    /** 对齐 trialSuccess_tl9：微信内提示浏览器打开，小米走应用商店，其它跳下载链接 */
    handleDownload() {
      if (this.isWeixin()) {
        this.showPop = true;
        return;
      }
      if (this.brand === "xiaomi") {
        window.location.href = "https://app.xiaomi.com/detail/1500555";
        return;
      }
      if (!this.downAppUrl) {
        return;
      }
      setTimeout(() => {
        window.location.href = this.downAppUrl;
      }, 50);
    },

    handlePopChange(show) {
      this.showPop = show;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 0.84rem 0.55rem 0.4rem;
  background: #fff;
  box-sizing: border-box;
}

.page__icon {
  width: 1.2rem;
  height: 1.2rem;
}

.page__title {
  margin-top: 0.29rem;
  color: #222;
  font-size: 0.32rem;
  font-weight: 500;
  line-height: 0.4rem;
}

.page__line {
  width: 100%;
  height: 1px;
  margin-top: 1.2rem;
  background: #d7d7d7;
}

.page__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 0.43rem;
}

.page__label {
  color: #222;
  font-size: 0.28rem;
  line-height: 0.4rem;
}

.page__value {
  color: #888;
  font-size: 0.28rem;
  line-height: 0.4rem;
}

.page__hint {
  width: 100%;
  margin-top: 0.54rem;
  color: #999;
  font-size: 0.24rem;
  line-height: 0.4rem;
}

.page__btn {
  width: 6.4rem;
  height: 1rem;
  margin-top: 0.73rem;
  border-radius: 0.5rem;
  background: #678cf9;
  color: #fff;
  font-size: 0.32rem;
  line-height: 1rem;
  text-align: center;
}
</style>
